export const SEARCH_FOCUS = 'SEARCH_FOCUS'
export const SEARCH_BLUR = 'SEARCH_BLUR'

export const SAVE_CONSULTANT = 'SAVE_CONSULTANT'
export const SAVE_CONSULTANT_SUCCESS = 'SAVE_CONSULTANT_SUCCESS'
export const SAVE_CONSULTANT_ERROR = 'SAVE_CONSULTANT_ERROR'

export const UNSAVE_CONSULTANT = 'UNSAVE_CONSULTANT'
export const UNSAVE_CONSULTANT_SUCCESS = 'UNSAVE_CONSULTANT_SUCCESS'
export const UNSAVE_CONSULTANT_ERROR = 'UNSAVE_CONSULTANT_ERROR'

export const FETCH_SAVED_CONSULTANTS = 'FETCH_SAVED_CONSULTANTS'
export const FETCH_SAVED_CONSULTANTS_SUCCESS = 'FETCH_SAVED_CONSULTANTS_SUCCESS'
export const FETCH_SAVED_CONSULTANTS_ERROR = 'FETCH_SAVED_CONSULTANTS_ERROR'

export const REGISTER = 'REGISTER'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_ERROR = 'REGISTER_ERROR'

export const LOG_IN = 'LOG_IN'
export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS'
export const LOG_IN_ERROR = 'LOG_IN_ERROR'

export const LOG_OUT = 'LOG_OUT'
export const LOG_OUT_SUCCESS = 'LOG_OUT_SUCCESS'
export const LOG_OUT_ERROR = 'LOG_OUT_ERROR'

export const CHECK_AUTH_STATUS = 'CHECK_AUTH_STATUS'
export const CHECK_AUTH_STATUS_SUCCESS = 'CHECK_AUTH_STATUS_SUCCESS'
export const CHECK_AUTH_STATUS_ERROR = 'CHECK_AUTH_STATUS_ERROR'

export const RESET_PASSWORD = 'RESET_PASSWORD'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR'

export const SET_AVAILABLE = 'SET_AVAILABLE'

export const CONTACT_CONSULTANT = 'CONTACT_CONSULTANT'
export const CONTACT_CONSULTANT_SUCCESS = 'CONTACT_CONSULTANT_SUCCESS'
export const CONTACT_CONSULTANT_ERROR = 'CONTACT_CONSULTANT_ERROR'

export const SAVE_SEARCH_QUERY_SUCCESS = 'SAVE_SEARCH_QUERY_SUCCESS'
export const SAVE_SEARCH_QUERY_ERROR = 'SAVE_SEARCH_QUERY_ERROR'

export const FETCH_USER_INFO = 'FETCH_USER_INFO'
export const FETCH_USER_INFO_SUCCESS = 'FETCH_USER_INFO_SUCCESS'
export const FETCH_USER_INFO_ERROR = 'FETCH_USER_INFO_ERROR'

export const CREATE_EXPERIENCE = 'CREATE_EXPERIENCE'
export const CREATE_EXPERIENCE_SUCCESS = 'CREATE_EXPERIENCE_SUCCESS'
export const CREATE_EXPERIENCE_ERROR = 'CREATE_EXPERIENCE_ERROR'

export const UPDATE_EXPERIENCE = 'UPDATE_EXPERIENCE'
export const UPDATE_EXPERIENCE_SUCCESS = 'UPDATE_EXPERIENCE_SUCCESS'
export const UPDATE_EXPERIENCE_ERROR = 'UPDATE_EXPERIENCE_ERROR'

export const DELETE_EXPERIENCE = 'DELETE_EXPERIENCE'
export const DELETE_EXPERIENCE_SUCCESS = 'DELETE_EXPERIENCE_SUCCESS'
export const DELETE_EXPERIENCE_ERROR = 'DELETE_EXPERIENCE_ERROR'

export const SEARCH = 'SEARCH'
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS'
export const SEARCH_ERROR = 'SEARCH_ERROR'

export const FETCH_SUGGESTIONS = 'FETCH_SUGGESTIONS'
export const FETCH_SUGGESTIONS_SUCCESS = 'FETCH_SUGGESTIONS_SUCCESS'
export const FETCH_SUGGESTIONS_ERROR = 'FETCH_SUGGESTIONS_ERROR'

export const FETCH_ROLE_SUGGESTIONS = 'FETCH_ROLE_SUGGESTIONS'
export const FETCH_ROLE_SUGGESTIONS_SUCCESS = 'FETCH_ROLE_SUGGESTIONS_SUCCESS'
export const FETCH_ROLE_SUGGESTIONS_ERROR = 'FETCH_ROLE_SUGGESTIONS_ERROR'

export const FETCH_TAG_SUGGESTIONS = 'FETCH_TAG_SUGGESTIONS'
export const FETCH_TAG_SUGGESTIONS_SUCCESS = 'FETCH_TAG_SUGGESTIONS_SUCCESS'
export const FETCH_TAG_SUGGESTIONS_ERROR = 'FETCH_TAG_SUGGESTIONS_ERROR'

export const FETCH_CONSULTANT = 'FETCH_CONSULTANT'
export const FETCH_CONSULTANT_SUCCESS = 'FETCH_CONSULTANT_SUCCESS'
export const FETCH_CONSULTANT_ERROR = 'FETCH_CONSULTANT_ERROR'

export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'

export const UPDATE_CONSULTANT_INTERESTS = 'UPDATE_CONSULTANT_INTERESTS'
export const UPDATE_CONSULTANT_INTERESTS_SUCCESS =
  'UPDATE_CONSULTANT_INTERESTS_SUCCESS'
export const UPDATE_CONSULTANT_INTERESTS_ERROR =
  'UPDATE_CONSULTANT_INTERESTS_ERROR'

export const UPDATE_CONSULTANT_START_DATE = 'UPDATE_CONSULTANT_START_DATE'
export const UPDATE_CONSULTANT_START_DATE_SUCCESS =
  'UPDATE_CONSULTANT_START_DATE_SUCCESS'
export const UPDATE_CONSULTANT_START_DATE_ERROR =
  'UPDATE_CONSULTANT_START_DATE_ERROR'

export const UPDATE_USER_INFO = 'UPDATE_USER_INFO'
export const UPDATE_USER_INFO_SUCCESS = 'UPDATE_USER_INFO_SUCCESS'
export const UPDATE_USER_INFO_ERROR = 'UPDATE_USER_INFO_ERROR'

export const COMPLETE_ONBOARDING = 'COMPLETE_ONBOARDING'

export const CUSTOMER_CONTACT = 'CUSTOMER_CONTACT'

export const SEND_MESSAGE = 'SEND_MESSAGE'
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS'
export const SEND_MESSAGE_ERROR = 'SEND_MESSAGE_ERROR'

export const SUBSCRIBE_TO_MESSAGES = 'SUBSCRIBE_TO_MESSAGES'
export const UNSUBSCRIBE_FROM_MESSAGES = 'UNSUBSCRIBE_FROM_MESSAGES'
export const ROOM_MESSAGES = 'ROOM_MESSAGES'

export const FETCH_SETTINGS = 'FETCH_SETTINGS'
export const FETCH_SETTINGS_SUCCESS = 'FETCH_SETTINGS_SUCCESS'
export const FETCH_SETTINGS_ERROR = 'FETCH_SETTINGS_ERROR'

export const UPDATE_SETTINGS = 'UPDATE_SETTINGS'
export const UPDATE_SETTINGS_SUCCESS = 'UPDATE_SETTINGS_SUCCESS'
export const UPDATE_SETTINGS_ERROR = 'UPDATE_SETTINGS_ERROR'

export const VISIT = 'VISIT'

export const SUBSCRIBE_TO_USER_ROOMS = 'SUBSCRIBE_TO_USER_ROOMS'
export const UNSUBSCRIBE_FROM_USER_ROOMS = 'UNSUBSCRIBE_FROM_USER_ROOMS'
export const USER_ROOMS = 'USER_ROOMS'

export const SUBSCRIBE_TO_ROOM_METADATA = 'SUBSCRIBE_TO_ROOM_METADATA'
export const UNSUBSCRIBE_FROM_ROOM_METADATA = 'UNSUBSCRIBE_FROM_ROOM_METADATA'
export const ROOM_METADATA = 'ROOM_METADATA'

export const FETCH_UNLISTED_CONSULTANTS = 'FETCH_UNLISTED_CONSULTANTS'
export const FETCH_UNLISTED_CONSULTANTS_SUCCESS =
  'FETCH_UNLISTED_CONSULTANTS_SUCCESS'
export const FETCH_UNLISTED_CONSULTANTS_ERROR =
  'FETCH_UNLISTED_CONSULTANTS_ERROR'

export const APPROVE_CONSULTANT = 'APPROVE_CONSULTANT'
export const APPROVE_CONSULTANT_SUCCESS = 'APPROVE_CONSULTANT_SUCCESS'
export const APPROVE_CONSULTANT_ERROR = 'APPROVE_CONSULTANT_ERROR'

export const HIDE_CONSULTANT = 'HIDE_CONSULTANT'
export const HIDE_CONSULTANT_SUCCESS = 'HIDE_CONSULTANT_SUCCESS'
export const HIDE_CONSULTANT_ERROR = 'HIDE_CONSULTANT_ERROR'



// WEBPACK FOOTER //
// ./src/actionTypes.js